/**
 * Title persisted on End Meeting.
 * Uses BrSE `peerMeetingTitle` when present; otherwise the title the user created locally.
 */
export function resolveMeetingTitleForSave(
  localTitle: string,
  peerMeetingTitle: string | null | undefined
): string {
  const peer = peerMeetingTitle?.trim()
  return peer ? peer : localTitle
}

/** Candidate titles when PATCH hits MEETING_TITLE_TAKEN (attempt 0 = base). */
export function buildTitleSuffixCandidate(baseTitle: string, attemptIndex: number): string {
  if (attemptIndex <= 0) return baseTitle
  return `${baseTitle} (${attemptIndex + 1})`
}
